export enum EConsommableDialyse {
    H16 = 1,
    H356 = 2,
    H162 = 3,
    H172 = 4,
    H355 = 5,
    TubeEndotoxine = 6,
}